import { render, staticRenderFns } from "./admissions.vue?vue&type=template&id=61c8cdfe"
import script from "./admissions.vue?vue&type=script&lang=js"
export * from "./admissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports